"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCodecCompatibility = checkCodecCompatibility;
function checkCodecCompatibility(codec) {
  var videoEl = document.createElement('video');
  var result = videoEl.canPlayType("video/mp4; codecs=\"".concat(codec, "\"")) === 'probably';
  videoEl.remove();
  return result;
}